import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';

import { LotteryFormData } from '@/lib/lottery2';

import { Field } from '..';

interface SelectProps {
  register: UseFormRegister<LotteryFormData>;
  field: Field;
}

const Select: FC<SelectProps> = ({ register, field }) => {
  const { name, label, required, pattern, options } = field;

  return (
    <div className="flex flex-col">
      <label className="text-overline mb-2">{label}</label>

      <select
        {...register(name, {
          required,
          ...(pattern ? { pattern } : {}),
        })}
        className="bg-black text-gray-2 text-body2 border-none rounded-2 px-4 py-3 teair:bg-air-mediumBlue teair:bg-opacity-20 teair:placeholder-white teair:text-air-mediumBlue"
        defaultValue=""
      >
        <option value="" disabled>
          -
        </option>

        {[...(options || [])].map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
